import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import {
    getAuthPending,
    changeStateConceptCertificate
} from '../../actions/certificationActions'
import { Translate } from '../../../language';
import { PersonIcon } from '../../../assets/icons/index'
import Modal from '../../../containers/Modal';
import inMemoryJWT from '../../../auth/inMemoryJwt';
import TitleSVG from '../../../utils/components/TitleSVG/TitleSVG';


const CertificateStateConceptAdmin = ({ history, getAuthPending, isLoadingListStateConceptCertificates, listStateConceptCertificate }) => {



    const [isValidate, setValidate] = useState(false)
   
    const [stateCertificate, setStateCertificate] = useState('')
    const [conceptCertificate, setConceptCertificate] = useState('')


    useEffect(() => {
        if (!(inMemoryJWT.getToken())) {
            inMemoryJWT.getRefreshedToken()
        }
        getAuthPending()
    }, [])

    useEffect(() => {
        if (conceptCertificate !== '' && stateCertificate !== '') {
            setValidate(true)

        }
        if (conceptCertificate === '' || stateCertificate === '') {
            setValidate(false)
        }
    }, [conceptCertificate])

    useEffect(() => {
        if (conceptCertificate !== '' && stateCertificate !== '') {
            setValidate(true)

        }
        if (conceptCertificate === '' || stateCertificate === '') {
            setValidate(false)
        }
    }, [stateCertificate])





    return (
        <div className="container-page scroll-menu">
            <TitleSVG Icon={PersonIcon}
                titleHighlight={'Lista'}
                title={' de solicitudes de verificación pendiente'} />
            <div className='d-flex centerContent mt-5'>
                {(listStateConceptCertificate?.length != 0) ? <div className='wrapper-5 column-gap row-gap container-width'>
                    {isLoadingListStateConceptCertificates ? <div>Cargando...</div> :
                        listStateConceptCertificate.map((stateConceptCertificate) => (
                            <div key={stateConceptCertificate._id} className="card-admin-padding card-admin">
                                <div className="tittle-card-admin center-text">{stateConceptCertificate.userID.name}</div>
                                <div className="tittle-card-admin center-text mb-1">{stateConceptCertificate.userID.lastname}</div>
                                <div className="text-content-card center-text">{stateConceptCertificate.state ===0 ? "Pendiente" : ""}</div>
                                <div className="btns-admin ml-2 mr-2 mt-3" onClick={() => { history.push("./CertificateUserAuthRequest/" + stateConceptCertificate._id) }}
                                >Ver Información</div>
                            </div>
                        ))
                    }
                </div> :
                    <div className='color-purple-dark text-fz-1-5 container-width '> {'No hay Solicitudes pendientes'}</div>
                }
            </div>

        </div>
    )
}

const mapStateToProps = (state) => {
    return {
        isLoadingListStateConceptCertificates: state.certificationAdmin.isLoadingListStateConceptCertificates,
        listStateConceptCertificate: state.certificationAdmin.listStateConceptCertificate
    }
}


export default connect(mapStateToProps, { getAuthPending, changeStateConceptCertificate })(CertificateStateConceptAdmin)